import {
  Component,
  ChangeDetectionStrategy,
  input,
  TemplateRef,
  inject,
  OnInit,
  HostListener,
} from '@angular/core';
import { MatDialogRef, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ZButtonComponent } from '../z-button/z-button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-z-dialog',
    templateUrl: './z-dialog.component.html',
    styleUrls: ['./z-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, MatIconButton, MatDialogClose, MatTooltip, MatIcon, CdkScrollable, MatDialogContent, MatDialogActions, ZButtonComponent, TranslatePipe]
})
export class ZDialogComponent implements OnInit {
  readonly dialogRef: MatDialogRef<ZDialogComponent> = inject(
    MatDialogRef<ZDialogComponent>
  );

  readonly title = input<string>();
  readonly customTitleTemplate = input<TemplateRef<unknown>>();
  readonly contentTemplate = input<TemplateRef<unknown>>();
  readonly actionButtonsTemplate = input<TemplateRef<unknown>>();
  readonly allowClose = input<boolean>(true);

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    if (this.allowClose()) {
      this.dialogRef.close();
    }
  }
}
